import { IGoal } from 'motw_core/Entity/IGoal';
import * as React from 'react';
import VerbConstants from 'motw_core/Constants/VerbConstants';
import { FormSelect } from '../../../../Shared/Form/Select/FormSelect';
import { CanSaveProperty } from './CanSaveProperty';
import GoalEditorPanel from './GoalEditorPanel';
import { HandleValueChange } from './HandleValueChange';

export const GoalVerb = ({ GEP, data }: { GEP: GoalEditorPanel, data: IGoal }) => (
	<div>
		<FormSelect
			id="goalVerb"
			label="verb"
			width="140px"
			suggestions={VerbConstants.Verbs.Active()}
			onChange={(event: any) => HandleValueChange(GEP, event.target.value, 'verb')}
			value={data.verb}
			readonly={!CanSaveProperty('verb')}
		/>
	</div>
);
